import { useState } from "react";
import { useQuery } from "@apollo/client";
import { Query } from "@/app/graphql/codegen";
import { FETCH_CHATS } from "@chat/graphql/queries/fetchChats";

export const useLatestChats = (count: number = 3) => {
    // TODO Better Typing
    const [latestChats, setLatestChats] = useState<Array<{ id: string; name: string; updatedAt: string }>>([]);

    useQuery<Pick<Query, "chats">>(FETCH_CHATS, {
        onCompleted: (data) => {
            const sortedChats = [...(data.chats ?? [])].sort((a, b) => Number(b.updatedAt) - Number(a.updatedAt)).slice(0, count);

            setLatestChats(sortedChats);
        },
    });

    return latestChats;
};
